/*
 * RMQ: name should be a route
 */

import { environment } from '../../../environments/environment';
import { BookingModelService } from '../services/booking-model.service';
import { InvoiceModelService } from '../services/invoice-model.service';
import { TimeTableService } from '../services/time-table.service';
import * as apexChartData from '../data/chart/apex';
import * as googleChartData from '../data/chart/google-chart';
import * as widget from '../data/chart/widget';
import { CashBookService } from '../services/cash-book.service';
import { OrdersByCategoriesComponent } from '../components/tables-charts/orders-by-categories/orders-by-categories.component';
import {
	defaultOrdersByCategoriesStyle,
	defaultTopSellingProductsStyle,
	inverseTableBackgroundStyle
} from '../data/chart/table';
import { TopSellingProductsComponent } from '../components/tables-charts/top-selling-products/top-selling-products.component';
import { ShippingModelService } from '../services/shipping-model.service';
import { TransactionModelService } from '../services/transaction-model.service';
import { CashJournalModelService } from '../services/cash-journal-model.service';
import { InverseTableBackgroundComponent } from '../components/tables-charts/inverse-table-background/inverse-table-background.component';

export const GlobalVariable: any = {
	// SUPER ADMIN PART
	ADMIN: { title: 'Administration', name: 'Administration', icon: 'settings' },
	ACCOUNT_MANAGERS: {
		title: 'Account Managers',
		name: 'account-managers',
		route: 'account-managers',
		svgIcon: 'stroke-user',
		isAdmin: true,
		isComponent: true,
		icon: 'admin'
	},
	SUBSCRIPTIONS: {
		code: 'SUBSCRIPTIONS',
		title: 'Subscriptions',
		name: 'Subscription',
		route: 'subscriptions',
		svgIcon: 'stroke-subscribe',
		isAdmin: true,
		isComponent: true,
		icon: 'admin'
	},
	BILLINGS: {
		code: 'BILLINGS',
		title: 'Billings',
		name: 'Billings',
		route: 'billings',
		svgImage: 'billings',
		isAdmin: true,
		isComponent: true,
		icon: 'admin'
	},
	// CONFIGURATION
	CONFIG: { title: 'General', name: 'General', icon: 'home' },
	PROJECT: {
		code: 'PROJECT',
		title: 'Projects',
		name: 'Project',
		route: 'projects',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		icon: 'admin',
		svgIcon: 'stroke-project',
		types: [
			{ code: 'DEFAULT', name: 'Default' },
			{ code: 'RESTAURANT', name: 'Restaurant' },
			{ code: 'COMMERCE', name: 'Commerce' },
			{ code: 'E-COMMERCE', name: 'E-Commerce' },
			{ code: 'LIBRARY', name: 'Library' },
			{ code: 'SALON', name: 'Salon' }
		],
		actions: ['List of Projects', 'Add new Project', 'Edit Project', 'Delete Project'],
		childComponents: ['PROJECT'],
		childRoute: [
			{ actionName: 'Add new Employee', route: 'add' },
			{ actionName: 'Edit Employee', route: 'edit' }
		]
	},
	LOAD: {
		code: 'LOAD',
		title: 'Loads',
		name: 'Load',
		route: 'loads',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		svgIcon: 'advance',
		actions: ['List of Loads', 'Add new Load', 'Edit Load', 'Delete Load'],
		childComponents: ['LOAD', 'PAYMENT_METHODS', 'PAYMENT_SOURCE', 'LOAD_CATEGORY'],
		childRoute: [],
		linkedApps: ['EXPENSE_MANAGEMENT']
	},
	PAYMENT_METHODS: {
		code: 'PAYMENT_METHODS',
		title: 'Payment Methods',
		name: 'Payment Method',
		route: '',
		isConfig: true,
		isModel: false,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		types: [
			{ code: 'espece', name: 'Espèces (Cash)', iconClass: 'fa fa-money' },
			{ code: 'virement', name: 'Virement', iconClass: 'fa fa-exchange' },
			{ code: 'cheque', name: 'Chèque', iconClass: 'fa fa-file-text-o' },
			{ code: 'traite', name: 'Traite', iconClass: 'fa fa-file-text-o' },
			{ code: 'credit', name: 'Crédit', iconClass: 'fa fa-file-text-o' },
			{ code: 'tpe', name: 'TPE', iconClass: 'fa fa-calculator' },
			{ code: 'cmi', name: 'CMI', iconClass: 'fa fa-credit-card-alt' },
			{ code: 'versement', name: 'Versement', iconClass: 'fa fa-arrow-circle-down' }
		],
		svgImage: 'payment-method-cash',
		svgIcon2: 'setting-payment',
		parentComponentRoute: 'loads',
		moduleName: 'PaymentMethod',
		actions: ['List of Payment Methods', 'Add new Payment Method', 'Edit Payment Method', 'Delete Payment Method'],
		childRoute: []
	},
	PAYMENT_SOURCE: {
		code: 'PAYMENT_SOURCE',
		title: 'Payment Sources',
		name: 'Payment Source',
		route: '',
		parentComponentRoute: 'loads',
		moduleName: 'PaymentSource',
		isConfig: true,
		isModel: false,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		svgImage: 'wallet',
		svgIcon2: 'wallet-point',
		actions: ['List of Payment Sources', 'Add new Payment Source', 'Edit Payment Source', 'Delete Payment Source'],
		childRoute: []
	},
	LOAD_CATEGORY: {
		code: 'LOAD_CATEGORY',
		title: 'Load Categories',
		name: 'Load Category',
		route: '',
		parentComponentRoute: 'loads',
		moduleName: 'LoadCategory',
		svgIcon: 'product-category',
		isConfig: true,
		isModel: false,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		actions: ['List of Load Categories', 'Add new Load Category', 'Edit Load Category', 'Delete Load Category'],
		childRoute: [],
		linkedApps: ['EXPENSE_MANAGEMENT']
	},
	PRODUCT: {
		code: 'PRODUCT',
		title: 'Products',
		name: 'Product',
		route: 'products',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		icon: 'job-search',
		svgIcon: 'products-config',
		types: [
			{ code: 'Alimentary', name: 'Alimentary' },
			{ code: 'Other', name: 'Other' }
		],
		actions: [
			'List of Products',
			'Config Products',
			'Add new Product',
			'Edit Product',
			'Duplicate Product',
			'Delete Product'
		],
		childComponents: ['PRODUCT', 'UNITY', 'SUPPLIER', 'CATEGORY', 'PRICE_CATEGORY'],
		childRoute: [
			{ actionName: 'Add new Product', route: 'add' },
			{ actionName: 'Edit Product', route: 'edit' }
		],
		linkedApps: [],
		linkedConfigs: ['CATEGORY', 'UNITY', 'PRICE_CATEGORY']
	},
	CATEGORY: {
		code: 'CATEGORY',
		title: 'Categories',
		name: 'Category',
		route: '',
		parentComponentRoute: 'products',
		moduleName: 'Category',
		svgIcon: 'product-category',
		isConfig: true,
		isModel: false,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		actions: ['List of Categories', 'Add new Category', 'Edit Category', 'Delete Category'],
		childRoute: [],
		linkedApps: [],
		linkedConfigs: ['PRODUCT']
	},
	SUB_CATEGORY: {
		code: 'SUB_CATEGORY',
		title: 'Sub Categories',
		name: 'Sub Category',
		route: '',
		parentComponentRoute: 'products',
		moduleName: 'Sub Category',
		svgIcon: 'product-category',
		isConfig: true,
		isModel: false,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		actions: ['List of Categories', 'Add new Category', 'Edit Category', 'Delete Category'],
		childRoute: [],
		linkedApps: [],
		linkedConfigs: ['PRODUCT']
	},
	UNITY: {
		code: 'UNITY',
		title: 'Unities',
		name: 'Unity',
		route: '',
		parentComponentRoute: 'products',
		moduleName: 'Unity',
		isConfig: true,
		isModel: false,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		svgImage: 'target-aim',
		actions: ['List of Unities', 'Add new Unity', 'Edit Unity', 'Delete Unity'],
		childRoute: [],
		linkedApps: [],
		linkedConfigs: ['PRODUCT']
	},
	SUPPLIER: {
		code: 'SUPPLIER',
		title: 'Suppliers',
		name: 'Supplier',
		route: 'suppliers',
		parentComponentRoute: 'products',
		moduleName: 'Supplier',
		svgIcon: 'stroke-user',
		isConfig: true,
		isModel: false,
		isComponent: true,
		isChildComponent: true,
		actions: ['List of Suppliers', 'Add new Supplier', 'Edit Supplier', 'Delete Supplier'],
		childRoute: [
			{ actionName: 'Add new Supplier', route: 'add' },
			{ actionName: 'Edit Supplier', route: 'edit' }
		],
		linkedApps: [],
		linkedConfigs: []
	},
	PRICE_CATEGORY: {
		code: 'PRICE_CATEGORY',
		title: 'Price Categories',
		name: 'Price Categories',
		route: '',
		parentComponentRoute: 'products',
		moduleName: 'PriceCategories',
		svgIcon: 'product-category',
		isConfig: true,
		isModel: false,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		actions: ['List of Price Categories', 'Add new Price Category', 'Edit Price Category', 'Delete Price Category'],
		childRoute: [],
		linkedApps: [],
		linkedConfigs: ['PRODUCT']
	},
	USER: {
		code: 'USER',
		title: 'Users',
		name: 'User',
		route: 'users',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		roles: ['User', 'Admin', 'Owner'],
		icon: 'user',
		svgIcon: 'stroke-user',
		actions: ['List of Users', 'Add new User', 'Edit User', 'Delete User'],
		childComponents: ['USER', 'ROLE'],
		childRoute: [
			{ actionName: 'Add new User', route: 'add' },
			{ actionName: 'Edit User', route: 'edit' }
		]
	},
	ROLE: {
		code: 'ROLE',
		title: 'Roles',
		name: 'Role',
		route: 'role',
		parentComponentRoute: 'users',
		moduleName: 'Role',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		isChildComponent: true,
		actions: ['List of Roles', 'Add new Role', 'Edit Role', 'Delete Role', 'View The Role Access'],
		childRoute: [
			{ actionName: 'Add new Role', route: 'add' },
			{ actionName: 'Edit Role', route: 'edit' }
		]
	},
	BOOKING_MODEL: {
		code: 'BOOKING_MODEL',
		title: 'Service Model',
		name: 'booking-models',
		route: 'booking-models',
		serviceClass: BookingModelService,
		icon: 'home',
		svgIcon: 'stroke-calendar',
		nickName: 'Booking',
		isConfig: true,
		isModel: true,
		isComponent: true,
		hasChildActions: true,
		appCode: 'BOOKING_MANAGEMENT',
		actions: ['List of Models', 'Add new Model', 'Edit Model', 'Config Model', 'Delete Model'],
		childComponents: [],
		childRoute: [
			{ actionName: 'Add new Model', route: 'add' },
			{ actionName: 'Edit Model', route: 'edit' },
			{ actionName: 'Config Model', route: 'config' }
		]
	},
	CASH_JOURNAL_MODEL: {
		code: 'CASH_JOURNAL_MODEL',
		title: 'Cash Journal Model',
		name: 'cash-journal-models',
		route: 'cash-journal-models',
		serviceClass: CashJournalModelService,
		icon: 'home',
		svgIcon: 'stroke-reports',
		nickName: 'Cash Journal',
		isConfig: true,
		isModel: true,
		isComponent: true,
		hasChildActions: true,
		appCode: 'CASH_JOURNAL',
		actions: ['List of Models', 'Add new Model', 'Edit Model', 'Config Model', 'Delete Model', 'Histories'],
		childComponents: [],
		childRoute: [
			{ actionName: 'Add new Model', route: 'add' },
			{ actionName: 'Edit Model', route: 'edit' },
			{ actionName: 'Config Model', route: 'config' },
			{ actionName: 'Histories', route: 'histories' }
		],
		appFields: {
			circleChart: [],
			widget: [{ type: 'number', field: 'balance', label: 'Balance' }],
			analyticsChart: []
		}
	},
	TRANSACTION_MODEL: {
		code: 'TRANSACTION_MODEL',
		title: 'Transaction Model',
		name: 'Transaction Model',
		route: 'transaction-models',
		serviceClass: TransactionModelService,
		icon: 'home',
		nickName: 'Transaction',
		svgImage: 'transaction-model',
		isConfig: true,
		isModel: true,
		isComponent: true,
		hasChildActions: true,
		appCode: 'TRANSACTION_MANAGEMENT',
		actions: ['List of Models', 'Add new Model', 'Edit Model', 'Config Model', 'Delete Model'],
		childComponents: [],
		childRoute: [
			{ actionName: 'Add new Model', route: 'add' },
			{ actionName: 'Edit Model', route: 'edit' },
			{ actionName: 'Config Model', route: 'config' }
		]
	},
	SHIPPING_MODEL: {
		code: 'SHIPPING_MODEL',
		title: 'Shipping Model',
		name: 'shipping-models',
		route: 'shipping-models',
		serviceClass: ShippingModelService,
		icon: 'home',
		nickName: 'Shipping',
		svgImage: 'delivery-truck-model',
		isConfig: true,
		isModel: true,
		isComponent: true,
		hasChildActions: true,
		appCode: 'SHIPPING_MANAGEMENT',
		actions: ['List of Models', 'Add new Model', 'Edit Model', 'Config Model', 'Delete Model'],
		childComponents: [],
		childRoute: [
			{ actionName: 'Add new Model', route: 'add' },
			{ actionName: 'Edit Model', route: 'edit' },
			{ actionName: 'Config Model', route: 'config' }
		]
	},
	HUMAN_RESOURCE_CONFIG: {
		code: 'HUMAN_RESOURCE_CONFIG',
		title: 'Human Resource',
		name: 'human-resource',
		route: 'human-resource',
		icon: 'home',
		nickName: 'Human Resource',
		isConfig: true,
		isModel: true,
		isComponent: true,
		hasChildActions: false,
		appCode: 'HUMAN_RESOURCE',
		actions: [],
		childComponents: ['EMPLOYEE', 'TIME_TABLE_MODEL', 'TEAM_MODEL']
	},
	EMPLOYEE: {
		code: 'EMPLOYEE',
		title: 'Employees',
		name: 'Employee',
		route: 'employee',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		isChildComponent: true,
		parentComponentRoute: 'human-resource',
		moduleName: 'Employee',
		actions: ['List of Employees', 'Add new Employee', 'Edit Employee', 'Delete Employee'],
		childRoute: [
			{ actionName: 'Add new Employee', route: 'add' },
			{ actionName: 'Edit Employee', route: 'edit' }
		],
		linkedApps: ['HUMAN_RESOURCE'],
		linkedConfigs: []
	},
	TIME_TABLE_MODEL: {
		code: 'TIME_TABLE_MODEL',
		title: 'Time Tables',
		name: 'time-table-models',
		route: 'time-table',
		serviceClass: TimeTableService,
		nickName: 'Time Table',
		isConfig: true,
		isModel: true,
		isComponent: true,
		hasChildActions: true,
		isChildComponent: true,
		parentComponentRoute: 'human-resource',
		moduleName: 'TimeTables',
		actions: [
			'List of Time Tables',
			'Add new Time Table',
			'Edit Time Table',
			'Duplicate Time Table',
			'Show Time Table',
			'Delete Time Table'
		],
		childRoute: [
			{ actionName: 'Add new Time Table', route: 'add' },
			{ actionName: 'Edit Time Table', route: 'edit' },
			{ actionName: 'Show Time Table', route: 'show' }
		],
		linkedApps: ['HUMAN_RESOURCE'],
		linkedConfigs: []
	},
	TEAM_MODEL: {
		code: 'TEAM_MODEL',
		title: 'Team',
		name: 'team',
		route: '',
		nickName: 'Team',
		isConfig: true,
		isModel: true,
		isComponent: false,
		isChildComponent: true,
		hasChildActions: true,
		parentComponentRoute: 'human-resource',
		moduleName: 'Team',
		actions: ['List of Teams', 'Add new Team', 'Edit Team', 'Delete Team'],
		childRoute: [],
		linkedApps: ['HUMAN_RESOURCE'],
		linkedConfigs: []
	},
	INVOICE_MODEL: {
		code: 'INVOICE_MODEL',
		title: 'Invoice Model',
		name: 'invoice-model',
		route: 'invoice-models',
		serviceClass: InvoiceModelService,
		icon: 'home',
		svgIcon: 'c-invoice',
		nickName: 'Invoice',
		isConfig: true,
		isModel: true,
		isComponent: true,
		hasChildActions: false,
		appCode: 'INVOICE_MANAGEMENT',
		actions: ['List of Models', 'Add new Model', 'Edit Model', 'Delete Model'],
		childComponents: [],
		childRoute: [
			{ actionName: 'Add new Model', route: 'add' },
			{ actionName: 'Edit Model', route: 'edit' }
		]
	},
	CUSTOM_TYPES: {
		code: 'CUSTOM_TYPES',
		title: 'Custom Inputs',
		name: 'custom-types',
		route: 'custom-types',
		icon: 'home',
		svgImage: 'textbox',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		childComponents: [],
		actions: ['List of Types', 'Add new Type', 'Edit Type', 'Delete Type'],
		childRoute: [
			{ actionName: 'Add new Type', route: 'add' },
			{ actionName: 'Edit Type', route: 'edit' }
		]
	},
	CHART_MODEL: {
		code: 'CHART_MODEL',
		title: 'Chart Model',
		name: 'chart-model',
		route: 'chart-model',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		childComponents: [],
		svgIcon: 'setting-analytics',
		svgIcon2: 'chart-model',
		actions: ['List of Charts', 'Add new Chart', 'Edit Chart', 'Delete Chart'],
		childRoute: [
			{ actionName: 'Add new Chart', route: 'add' },
			{ actionName: 'Edit Chart', route: 'edit' }
		]
	},
	VEHICLE: {
		code: 'VEHICLE',
		title: 'Vehicle',
		name: 'Vehicle',
		route: 'vehicle',
		nickName: 'Vehicle',
		svgIcon: 'vehicles',
		isConfig: true,
		isModel: true,
		isChildModel: true,
		isComponent: true,
		hasChildActions: true,
		icon: 'job-search',
		appCode: 'BOOKING_MANAGEMENT',
		actions: ['List of Vehicles', 'Add new Vehicle', 'Edit Vehicle', 'Delete Vehicle'],
		childRoute: [
			{ actionName: 'Add new Vehicle', route: 'add' },
			{ actionName: 'Edit Vehicle', route: 'edit' }
		]
	},
	API_INTEGRATION_MODEL: {
		code: 'API_INTEGRATION_MODEL',
		title: 'Api Integration',
		name: 'api-integration-models',
		route: 'api-integration-models',
		// serviceClass: CashJournalModelService,
		icon: 'home',
		svgIcon: 'stroke-api',
		nickName: 'Api Integration',
		isConfig: true,
		isModel: false,
		isComponent: true,
		hasChildActions: true,
		appCode: 'API_INTEGRATION_MODEL',
		actions: ['List of Models', 'Add new Model', 'Edit Model', 'Config Model', 'Delete Model', 'Histories'],
		childComponents: [],
		childRoute: [
			{ actionName: 'Add new Model', route: 'add' },
			{ actionName: 'Edit Model', route: 'edit' },
			{ actionName: 'Config Model', route: 'config' },
			{ actionName: 'Histories', route: 'histories' }
		],
		appFields: {
			circleChart: [],
			widget: [{ type: 'number', field: 'balance', label: 'Balance' }],
			analyticsChart: []
		}
	},
	APPLICATIONS: {
		code: 'APPLICATIONS',
		title: 'Applications',
		name: 'applications',
		route: 'applications',
		icon: 'job-search',
		svgIcon: 'stroke-social',
		isConfig: true,
		isComponent: true,
		actions: ['List of applications', 'Disable an application']
	},
	APPLICATIONS_MODELS: {
		'booking-models': 'booking-management',
		'transaction-models': 'transaction-management',
		'shipping-models': 'shipping-management',
		'time-table-models': 'human-resource',
		'human-resource': 'human-resource',
		'invoice-models': 'invoice-management',
		vehicle: 'booking-management'
	},
	// DASHBOARD
	DASHBOARD: {
		title: 'Dashboard',
		name: 'dashboard',
		route: 'dashboard',
		icon: 'inbox',
		svgIcon: 'stroke-charts',
		svgIcon2: 'stroke-widget',
		isComponent: true,
		actions: [
			'Number of products in stock',
			'Total of users',
			'Total of expenses',
			'Statistics of expenses',
			'Stock'
		],
		order: 1
	},
	// APPLICATIONS
	STOCK: {
		code: 'STOCK_MANAGEMENT',
		title: 'Stock Management',
		name: 'stock-management',
		route: 'stock-management',
		nickName: 'Stock',
		icon: 'inbox',
		svgIcon: 'stroke-board',
		isComponent: true,
		actions: [
			'List of products in stock',
			'Create a purchase order',
			'Deposit in stock',
			'Trash from stock',
			'Withdraw from stock',
			'Config stock',
			'Histories'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Create a purchase order', route: 'supplier-purchase' },
			{ actionName: 'Histories', route: 'histories' }
		],
		// app details
		isApp: true,
		logo: 'stock-management',
		isActive: false,
		img: 'assets/images/applications/stock-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: [
			'Histories',
			'Filters',
			'Search by product name',
			'Access by user role',
			'Deposit in stock',
			'Withdraw from stock',
			'Trash from stock'
		],
		appFields: {
			circleChart: [],
			widget: [],
			analyticsChart: [{ field: 'category', label: 'Category', type: 'text' }]
		},
		linkedConfigs: ['SUPPLIER'],
		order: 2
	},
	SUPPLIER_PURCHASE: {
		code: 'SUPPLIER_PURCHASE',
		title: 'Supplier Purchase',
		name: 'supplier-purchase',
		route: 'supplier-purchase',
		nickName: 'Purchase',
		icon: 'inbox',
		svgIcon: 'stroke-board',
		isComponent: true,
		actions: ['Pos'],
		hasChildActions: true,
		childRoute: [],
		// app details
		isApp: false,
		logo: 'stock-management',
		isActive: false,
		img: 'assets/images/applications/stock-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: [],
		appFields: {
			circleChart: [],
			widget: [],
			analyticsChart: []
		},
		linkedConfigs: []
	},
	CASH_JOURNAL: {
		code: 'CASH_JOURNAL',
		title: 'Cash Journal',
		name: 'cash-journal',
		route: 'cash-journal',
		nickName: 'Cash Book',
		icon: 'inbox',
		svgIcon: 'stroke-reports',
		isComponent: true,
		actions: [
			'List of cashBooks',
			'Add new Cash book',
			'Edit Cash book',
			'Edit Cash book Date',
			'Remove Cash Book row',
			'View Cash book',
			'Delete Cash book'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add new Cash book', route: 'add' },
			{ actionName: 'Edit Cash book', route: 'edit' },
			{ actionName: 'View Cash book', route: 'show' }
		],
		// app details
		isApp: true,
		logo: 'cash-journal',
		isActive: false,
		img: 'assets/images/applications/cash-journal.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Filters', 'Search', 'Access by user role'],
		appFields: {
			circleChart: [],
			widget: [
				{ field: 'balance', label: 'Balance', type: 'number' },
				{ field: 'totalInputs', label: 'Total Inputs', type: 'number' },
				{ field: 'totalOutputs', label: 'Total Outputs', type: 'number' }
			],
			analyticsChart: [{ field: 'balance', label: 'Balance', type: 'number' }]
		},
		hasModel: true,
		model: 'CASH_BOOK',
		linkedConfigs: [],
		order: 5
	},
	CASH_BOOK: {
		code: 'CASH_BOOK',
		title: 'Cash Book',
		name: 'cash-book',
		nickName: 'cash book',
		icon: 'inbox',
		serviceClass: CashBookService,
		isComponent: true,
		actions: [],
		logo: 'fa-calendar',
		isActive: false,
		img: 'assets/images/applications/cash-journal.svg',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Filters', 'Search', 'Access by user role']
	},
	EXPENSE_MANAGEMENT: {
		code: 'EXPENSE_MANAGEMENT',
		title: 'Expense Management',
		name: 'expense-management',
		route: 'expense-management',
		nickName: 'Expense',
		icon: 'inbox',
		svgIcon: 'expense',
		isComponent: true,
		actions: [
			'List of monthly loads',
			'Add new expense',
			'Edit monthly loads',
			'List of yearly loads',
			'Edit of yearly loads',
			'List of other loads',
			'Edit of other loads',
			'Delete of other loads',
			'Expenditure Calculator',
			'Histories'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Histories', route: 'histories' },
			{ actionName: 'Expenditure Calculator', route: 'calculator' }
		],
		// app details
		isApp: true,
		logo: 'expense-management',
		isActive: false,
		img: 'assets/images/applications/expense-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Manage monthly, yearly and custom loads', 'Histories', 'Filters', 'Search', 'Access by user role'],
		appFields: {
			circleChart: [
				{ type: 'text', field: 'category', label: 'Category' },
				{ type: 'text', field: 'status', label: 'Status' },
				{ type: 'text', field: 'paymentMethod', label: 'Payment Method' },
				{ type: 'text', field: 'paymentSource', label: 'Payment Source' },
				{ type: 'text', field: 'date', label: 'Date' }
			],
			widget: [{ field: 'amount', label: 'Amount', type: 'number' }],
			analyticsChart: [{ field: 'amount', label: 'Amount', type: 'number' }]
		},
		linkedConfigs: ['LOAD', 'LOAD_CATEGORY', 'PAYMENT_METHODS', 'PAYMENT_SOURCE'],
		order: 7
	},
	VENDOR_MANAGEMENT: {
		code: 'VENDOR_MANAGEMENT',
		title: 'Vendor Management',
		name: 'vendor-management',
		route: 'vendor-management',
		nickName: 'Vendor',
		icon: 'inbox',
		svgImage: 'handshake',
		isComponent: true,
		actions: [
			'List of vendors',
			'Show vendor transactions',
			'Add new Vendor',
			'Edit Vendor',
			'Add new transaction',
			'Delete Vendor',
			'Histories'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add new Vendor', route: 'add' },
			{ actionName: 'Edit Vendor', route: 'edit' },
			{ actionName: 'Show vendor transactions', route: 'transactions' },
			{ actionName: 'Histories', route: 'histories' }
		],
		// app details
		isApp: true,
		logo: 'vendor-management',
		isActive: false,
		img: 'assets/images/applications/vendor-management.webp',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Manage monthly, yearly and custom loads', 'Histories', 'Filters', 'Search', 'Access by user role'],
		appFields: {
			circleChart: [],
			widget: [],
			analyticsChart: []
		},
		order: 4
	},
	Earning_MANAGEMENT: {
		code: 'Earning_MANAGEMENT',
		title: 'Earning Management',
		name: 'earning-management',
		icon: 'inbox',
		nickName: 'Earning',
		isComponent: true,
		actions: [],
		// app details
		isApp: false,
		logo: 'earning-management',
		isActive: false,
		img: 'assets/images/applications/earning-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Manage monthly, yearly and custom loads', 'Histories', 'Filters', 'Search', 'Access by user role'],
		appFields: {
			circleChart: [],
			widget: [],
			analyticsChart: []
		}
	},
	HUMAN_RESOURCE: {
		code: 'HUMAN_RESOURCE',
		title: 'Human Resource',
		name: 'human-resource',
		route: 'human-resource',
		icon: 'inbox',
		nickName: 'Human Resource',
		isComponent: true,
		hasChildActions: true,
		isApp: true,
		isChildApp: false,
		isActive: false,
		actions: [],
		childApps: ['ABSENCE_TRACKER', 'SALARY_MANAGEMENT', 'SALARY_HISTORY'],
		logo: 'human-resource',
		img: 'assets/images/applications/human-resource.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: [
			'Manage all user activities',
			'Manage Salaries',
			'Histories',
			'Filters',
			'Search',
			'Access by user role'
		],
		linkedConfigs: ['EMPLOYEE'],
		order: 9
	},
	SALARY_MANAGEMENT: {
		code: 'SALARY_MANAGEMENT',
		title: 'Salary Management',
		name: 'salary-management',
		route: 'salary',
		icon: 'home',
		nickName: 'Salary',
		svgImage: 'pay',
		isConfig: false,
		isComponent: true,
		hasChildActions: true,
		isChildApp: true,
		isApp: false,
		actions: ['List of Salaries', 'Manage Salaries', 'Edit salaries', 'Delete salaries'],
		childRoute: [
			{ actionName: 'Add new Employee', route: 'add' },
			{ actionName: 'Edit Employee', route: 'edit' }
		]
	},
	ABSENCE_TRACKER: {
		code: 'ABSENCE_TRACKER',
		title: 'Absence Tracker',
		name: 'absence-tracker',
		route: 'absence',
		icon: 'home',
		nickName: 'Absence',
		svgImage: 'absence',
		isConfig: false,
		isComponent: true,
		hasChildActions: true,
		isChildComponent: true,
		isApp: false,
		isChildApp: true,
		actions: ['List of Absence Tracker', 'Select Date', 'Add Absence', 'Edit Absence', 'Delete Absence'],
		childRoute: [],
		hasModel: true,
		model: 'TIME_TABLE_MODEL',
		appFields: {
			circleChart: [],
			widget: [],
			analyticsChart: [],
			tableChart: [{ field: 'status', label: 'Status', type: 'text' }]
		}
	},
	BOOKING_MANAGEMENT: {
		code: 'BOOKING_MANAGEMENT',
		title: 'Service Management',
		name: 'booking-management',
		route: 'booking-management',
		icon: 'home',
		svgIcon: 'stroke-calendar',
		nickName: 'Service',
		isComponent: true,
		actions: [
			'List of bookings',
			'Calendar',
			'Add booking',
			'Edit booking',
			'Delete booking',
			'Show booking history',
			'Config booking',
			'Add invoice',
			'Edit invoice',
			'Show invoice',
			'Add new Load',
			'Edit Load',
			'Histories'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add booking', route: 'add' },
			{ actionName: 'Edit booking', route: 'edit' },
			{ actionName: 'Histories', route: 'histories' },
			{ actionName: 'Calendar', route: 'calendar' }
		],
		// app details
		isApp: true,
		logo: 'booking-management',
		isActive: false,
		img: 'assets/images/applications/booking-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Option 1', 'Option 2', 'Histories', 'Filters', 'Search', 'Access by user role'],
		hasModel: true,
		model: 'BOOKING_MODEL',
		appFields: {
			circleChart: [
				{ type: 'text', field: 'status', label: 'Status' },
				{ type: 'text', field: 'paymentStatus', label: 'Payment Status' }
			],
			widget: [
				{ type: 'number', field: 'totalAmount', label: 'Total Amount' },
				{ type: 'number', field: 'profit', label: 'Profit' }
			],
			analyticsChart: [
				{ type: 'number', field: 'totalAmount', label: 'Total Amount' },
				{ type: 'number', field: 'profit', label: 'Profit' }
			]
		},
		order: 4
	},
	TRANSACTION_MANAGEMENT: {
		code: 'TRANSACTION_MANAGEMENT',
		title: 'Transaction Management',
		name: 'Transaction Management',
		route: 'transaction-management',
		icon: 'home',
		svgImage: 'handshake',
		nickName: 'Transaction',
		isComponent: true,
		actions: [
			'List of transactions',
			'Add transaction',
			'Edit transaction',
			'Delete transaction',
			'Show transaction history',
			'Config transaction',
			'Add invoice',
			'Edit invoice',
			'Show invoice',
			'Add new Load',
			'Edit Load',
			'Histories'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add transaction', route: 'add' },
			{ actionName: 'Edit transaction', route: 'edit' },
			{ actionName: 'Histories', route: 'histories' }
		],
		// app details
		isApp: true,
		logo: 'transaction-management',
		isActive: false,
		img: 'assets/images/applications/transaction-management.webp',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Option 1', 'Option 2', 'Histories', 'Filters', 'Search', 'Access by user role'],
		hasModel: true,
		model: 'TRANSACTION_MODEL',
		appFields: {
			circleChart: [
				{ type: 'text', field: 'status', label: 'Status' },
				{ type: 'text', field: 'paymentStatus', label: 'Payment Status' }
			],
			widget: [
				{ type: 'number', field: 'totalAmount', label: 'Total Amount' },
				{ type: 'number', field: 'profit', label: 'Profit' }
			],
			analyticsChart: [
				{ type: 'number', field: 'totalAmount', label: 'Total Amount' },
				{ type: 'number', field: 'profit', label: 'Profit' }
			]
		},
		order: 6
	},
	SHIPPING_MANAGEMENT: {
		code: 'SHIPPING_MANAGEMENT',
		title: 'Shipping Management',
		name: 'shipping-management',
		route: 'shipping-management',
		icon: 'home',
		nickName: 'Shipping',
		isComponent: true,
		actions: [
			'List of shippings',
			'Add shipping',
			'Edit shipping',
			'Print shipping',
			'Delete shipping',
			'Show shipping history',
			'Config shipping',
			'Add new Load',
			'Edit Load',
			'Pickup Requests',
			'Histories',
			'Cities'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add shipping', route: 'add' },
			{ actionName: 'Edit shipping', route: 'edit' },
			{ actionName: 'Pickup Requests', route: 'pickup' },
			{ actionName: 'Histories', route: 'histories' },
			{ actionName: 'Cities', route: 'cities' }
		],
		// app details
		isApp: true,
		logo: 'shipping-management-icon',
		isActive: false,
		img: 'assets/images/applications/shipping-management.webp',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Option 1', 'Option 2', 'Histories', 'Filters', 'Search', 'Access by user role'],
		hasModel: true,
		model: 'SHIPPING_MODEL',
		appFields: {
			circleChart: [],
			widget: [],
			analyticsChart: []
		},
		order: 11
	},
	ORDERS_MANAGEMENT: {
		code: 'ORDERS_MANAGEMENT',
		title: 'Orders Management',
		name: 'orders-management',
		route: 'orders-management',
		icon: 'home',
		svgIcon: 'orders',
		nickName: 'Order',
		isComponent: true,
		actions: [
			'List of orders',
			'Add order',
			'Edit order',
			'Delete order',
			'Config orders',
			'Orders Calculator',
			'Show invoice'
		],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add order', route: 'add' },
			{ actionName: 'Edit order', route: 'edit' },
			{ actionName: 'Orders Calculator', route: 'calculator' }
		],
		// app details
		isApp: true,
		logo: 'order-management2',
		isActive: false,
		img: 'assets/images/applications/order-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Option 1', 'Option 2', 'Histories', 'Filters', 'Search', 'Access by user role'],
		appFields: {
			circleChart: [
				{ type: 'text', field: 'items.product', label: 'Product' },
				{ type: 'text', field: 'status', label: 'Status' },
				{ type: 'text', field: 'paymentStatus', label: 'Payment Status' }
			],
			widget: [
				{ type: 'number', field: 'totalPrice', label: 'Total Sales' },
				{ type: 'number', field: 'totalExpenses', label: 'Total Expenses' },
				{ type: 'number', field: 'profit', label: 'Profit' },
				{ type: 'number', field: 'shopping-cart', label: 'Shopping Cart' }
			],
			analyticsChart: [
				{ type: 'number', field: 'totalPrice', label: 'Total Sales' },
				{ type: 'number', field: 'totalExpenses', label: 'Total Expenses' },
				{ type: 'number', field: 'profit', label: 'Profit' }
			]
		},
		linkedConfigs: [],
		order: 3
	},
	INVOICE_MANAGEMENT: {
		code: 'INVOICE_MANAGEMENT',
		title: 'Invoice Management',
		name: 'invoice-management',
		route: 'invoice-management',
		icon: 'home',
		svgIcon: 'c-invoice',
		nickName: 'Invoice',
		isComponent: true,
		actions: ['List of invoices', 'Add invoice', 'Edit invoice', 'Delete invoice', 'Show invoice', 'Print invoice'],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add invoice', route: 'add' },
			{ actionName: 'Edit invoice', route: 'edit' }
		],
		// app details
		isApp: true,
		logo: 'invoice-management',
		isActive: false,
		img: 'assets/images/applications/invoice-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Filters', 'Search', 'Access by user role'],
		hasModel: true,
		model: 'INVOICE_MODEL',
		appFields: {
			circleChart: [{ field: 'paymentStatus', label: 'Payment Status', type: 'text' }],
			widget: [
				{ field: 'total', label: 'Total', type: 'number' },
				{ field: 'invoiceNumber', label: 'Invoice', type: 'text' }
			],
			analyticsChart: [
				{ field: 'total', label: 'Total', type: 'number' },
				{ field: 'paymentStatus', label: 'Payment Status', type: 'text' }
			]
		},
		order: 10
	},
	TURNOVER_MANAGEMENT: {
		code: 'TURNOVER_MANAGEMENT',
		title: 'Turnover Management',
		name: 'turnover-management',
		route: 'turnover-management',
		icon: 'inbox',
		svgImage: 'money-bag',
		nickName: 'Turnover',
		isComponent: true,
		actions: ['List of turnovers', 'Add turnover', 'Edit turnover', 'Delete turnover', 'Histories'],
		hasChildActions: true,
		childRoute: [
			{ actionName: 'Add booking', route: 'add' },
			{ actionName: 'Edit booking', route: 'edit' },
			{ actionName: 'Histories', route: 'histories' }
		],
		// app details
		isApp: true,
		logo: 'turnover-management',
		isActive: false,
		img: 'assets/images/applications/turnover-management.png',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: ['Option 1', 'Option 2', 'Histories', 'Filters', 'Search', 'Access by user role'],
		appFields: {
			circleChart: [],
			widget: [
				{ field: 'amount', label: 'Amount', type: 'number' },
				{ field: 'profit', label: 'Profit', type: 'number' }
			],
			analyticsChart: [
				{ field: 'amount', label: 'Amount', type: 'number' },
				{ field: 'profit', label: 'Profit', type: 'number' }
			]
		},
		order: 8
	},
	TASKS_MANAGEMENT: {
		code: 'TASKS_MANAGEMENT',
		title: 'Tasks Management',
		name: 'tasks-management',
		icon: 'home',
		nickName: 'Tasks',
		isComponent: true,
		route: 'tasks-management',
		actions: [],
		// app details
		//isApp: true,
		logo: 'logo',
		isActive: false,
		img: 'assets/images/applications/gestion-de-stock.svg',
		description:
			'Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression.',
		options: []
	},
	// HISTORIES
	STOCK_HISTORY: {
		code: 'STOCK_HISTORY',
		title: 'Stock Histories',
		name: 'stock-histories',
		route: 'stock-histories',
		icon: 'inbox',
		nickName: 'Stock Histories',
		isComponent: true,
		actions: ['Edit deposit']
	},
	EXPENSE_HISTORY: {
		code: 'EXPENSE_HISTORY',
		title: 'Expense Histories',
		name: 'expense-histories',
		route: 'expense-histories',
		icon: 'inbox',
		nickName: 'Expense Histories',
		isComponent: true,
		actions: []
	},
	SALARY_HISTORY: {
		code: 'SALARY_HISTORY',
		title: 'Salary Histories',
		name: 'salary-histories',
		route: 'salary-histories',
		icon: 'inbox',
		nickName: 'Salary Histories',
		isConfig: false,
		isComponent: true,
		hasChildActions: true,
		isChildComponent: true,
		isApp: false,
		isChildApp: true,
		actions: ['List of Salary Histories'],
		childRoute: []
	},
	TURNOVER_HISTORY: {
		code: 'TURNOVER_HISTORY',
		title: 'Turnover Histories',
		name: 'turnover-histories',
		route: 'turnover-histories',
		icon: 'inbox',
		nickName: 'Turnover Histories',
		isComponent: true,
		actions: []
	},
	// VARIABLES
	SECRET: 'Elmir_2024.',
	SUBSCRIPTION_PACKS: ['Free', 'Free-trial', 'Popular', 'Medium', 'Premium'],
	countries: [{ _id: 'Morocco', name: 'Morocco' }],
	CURRENCIES: [
		{ _id: 'DH', name: 'Dhs' },
		{ _id: 'MAD', name: 'MAD' }
	],
	CURRENT_CURRENCY: 'Dhs',
	frequencies: [
		{ _id: 'Monthly', name: 'Monthly' },
		{ _id: 'Yearly', name: 'Yearly' }
	],
	datePickerConfig: {
		default: {
			rangeInputFormat: 'MMM DD, YYYY',
			dateInputFormat: 'MMM DD, YYYY',
			containerClass: 'theme-dark-blue',
			selectWeekDateRange: true
		},
		month: {
			minMode: 'month',
			dateInputFormat: 'MMM, YYYY',
			containerClass: 'theme-dark-blue'
		},
		year: {
			minMode: 'year',
			dateInputFormat: 'YYYY',
			containerClass: 'theme-dark-blue'
		}
	},
	DEFAULTROLE: {
		defaultComponentAceess: [
			{
				name: '',
				isActive: false,
				actions: [
					{
						name: '',
						isActive: false
					}
				]
			}
		]
	},
	EXPENSE_HEADER: [
		{ key: 'name', label: 'Load Name', renameLabel: 'Load Name', required: true },
		{ key: 'loadCategory', label: 'Load Category', renameLabel: 'Load Category', required: true },
		{ key: 'amount', label: 'Amount', renameLabel: 'Amount', required: true },
		{ key: 'paymentMethod', label: 'Payment Method', renameLabel: 'Payment Method', required: true },
		{ key: 'paymentSource', label: 'Payment Source', renameLabel: 'Payment Source', required: true },
		{ key: 'date', label: 'Date', renameLabel: 'Date', required: true },
		{ key: 'description', label: 'Description', renameLabel: 'Description', required: true }
	],
	ALLOWEDMIMETYPES: [
		'application/vnd.ms-excel',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'application/vnd.ms-excel.sheet.macroEnabled.12',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
		'application/vnd.ms-excel.template.macroEnabled.12',
		'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
		'text/csv',
		'text/tab-separated-values'
	],

	server: {
		host: environment.apiUrl
	}
};

GlobalVariable.CURRENT_CURRENCY = GlobalVariable.CURRENCIES.length > 0 ? GlobalVariable.CURRENCIES[0].name : '';

export const GlobalCities: any = [
	{
		_id: '0',
		name: 'Afourar',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '1',
		name: 'Agadir',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '2',
		name: 'Agdz',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '3',
		name: 'Aghbala',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '4',
		name: 'Agni Izimmer',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '5',
		name: 'Agourai',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '6',
		name: 'Ahfir',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '7',
		name: 'Ain El Aouda',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '8',
		name: 'Ain Taoujdate',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '9',
		name: 'Ait Daoud',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '10',
		name: 'Ajdir‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '11',
		name: 'Akchour',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '12',
		name: 'Akka',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '13',
		name: 'Aklim',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '14',
		name: 'Aknoul‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '15',
		name: 'Al Aroui',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '16',
		name: 'Al Hoceïma‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '17',
		name: 'Alnif',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '18',
		name: 'Amalou Ighriben',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '19',
		name: 'Amizmiz',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '20',
		name: 'Anzi',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '21',
		name: 'Aoufous',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '22',
		name: 'Aoulouz',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '23',
		name: 'Aourir',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '24',
		name: 'Arazane',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '25',
		name: 'Arbaoua',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '26',
		name: 'Arfoud',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '27',
		name: 'Assa',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '28',
		name: 'Assahrij',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '29',
		name: 'Assilah',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '30',
		name: 'Awsard',
		region: '12',
		country: 'Morocco'
	},
	{
		_id: '31',
		name: 'Azemmour',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '32',
		name: 'Azilal',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '33',
		name: 'Azrou',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '34',
		name: 'Aïn Bni Mathar',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '35',
		name: 'Aïn Cheggag',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '36',
		name: 'Aïn Dorij',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '37',
		name: 'Aïn Erreggada',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '38',
		name: 'Aïn Harrouda',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '39',
		name: 'Aïn Jemaa',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '40',
		name: 'Aïn Karma',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '41',
		name: 'Aïn Leuh',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '42',
		name: 'Aït Attab',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '43',
		name: 'Aït Baha',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '44',
		name: 'Aït Boubidmane',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '45',
		name: 'Aït Hichem‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '46',
		name: 'Aït Iaâza',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '47',
		name: 'Aït Ishaq',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '48',
		name: 'Aït Majden',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '49',
		name: 'Aït Melloul',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '50',
		name: 'Aït Ourir',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '51',
		name: 'Aït Yalla',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '52',
		name: 'Bab Berred',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '53',
		name: 'Bab Taza',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '54',
		name: 'Bejaâd',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '55',
		name: 'Ben Ahmed',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '56',
		name: 'Ben Guerir',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '57',
		name: 'Ben Sergao',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '58',
		name: 'Ben Taïeb',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '59',
		name: 'Ben Yakhlef',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '60',
		name: 'Beni Ayat',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '61',
		name: 'Benslimane',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '62',
		name: 'Berkane',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '63',
		name: 'Berrechid',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '64',
		name: 'Bhalil',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '65',
		name: 'Bin elouidane',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '66',
		name: 'Biougra',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '67',
		name: 'Bir Jdid',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '68',
		name: 'Bni Ansar',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '69',
		name: 'Bni Bouayach‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '70',
		name: 'Bni Chiker',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '71',
		name: 'Bni Drar',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '72',
		name: 'Bni Hadifa‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '73',
		name: 'Bni Tadjite',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '74',
		name: 'Bouanane',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '75',
		name: 'Bouarfa',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '76',
		name: 'Boudnib',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '77',
		name: 'Boufakrane',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '78',
		name: 'Bouguedra',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '79',
		name: 'Bouhdila',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '80',
		name: 'Bouizakarne',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '81',
		name: 'Boujdour‎',
		region: '11',
		country: 'Morocco'
	},
	{
		_id: '82',
		name: 'Boujniba',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '83',
		name: 'Boulanouare',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '84',
		name: 'Boulemane',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '85',
		name: 'Boumalne-Dadès',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '86',
		name: 'Boumia',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '87',
		name: 'Bouskoura',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '88',
		name: 'Bouznika',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '89',
		name: 'Bradia',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '90',
		name: 'Brikcha',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '91',
		name: 'Bzou',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '92',
		name: 'Béni Mellal',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '93',
		name: 'Casablanca',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '94',
		name: 'Chefchaouen',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '95',
		name: 'Chichaoua',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '96',
		name: 'Dar Bni Karrich',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '97',
		name: 'Dar Chaoui',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '98',
		name: 'Dar El Kebdani',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '99',
		name: 'Dar Gueddari',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '100',
		name: 'Dar Oulad Zidouh',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '101',
		name: 'Dcheira El Jihadia',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '102',
		name: 'Debdou',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '103',
		name: 'Demnate',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '104',
		name: 'Deroua',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '105',
		name: 'Douar Kannine',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '106',
		name: "Dra'a",
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '107',
		name: 'Drargua',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '108',
		name: 'Driouch',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '109',
		name: 'Echemmaia',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '110',
		name: 'El Aïoun Sidi Mellouk',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '111',
		name: 'El Borouj',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '112',
		name: 'El Gara',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '113',
		name: 'El Guerdane',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '114',
		name: 'El Hajeb',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '115',
		name: 'El Hanchane',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '116',
		name: 'El Jadida',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '117',
		name: 'El Kelaâ des Sraghna',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '118',
		name: 'El Ksiba',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '119',
		name: 'El Marsa‎',
		region: '11',
		country: 'Morocco'
	},
	{
		_id: '120',
		name: 'El Menzel',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '121',
		name: 'El Ouatia',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '122',
		name: 'Elkbab',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '123',
		name: 'Er-Rich',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '124',
		name: 'Errachidia',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '125',
		name: 'Es-Semara',
		region: '11',
		country: 'Morocco'
	},
	{
		_id: '126',
		name: 'Essaouira',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '127',
		name: 'Fam El Hisn',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '128',
		name: 'Farkhana',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '129',
		name: 'Figuig',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '130',
		name: 'Fnideq',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '131',
		name: 'Foum Jamaa',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '132',
		name: 'Foum Zguid',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '133',
		name: 'Fquih Ben Salah',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '134',
		name: 'Fraïta',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '135',
		name: 'Fès',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '136',
		name: 'Gardmit',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '137',
		name: 'Ghafsai‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '138',
		name: 'Ghmate',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '139',
		name: 'Goulmima',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '140',
		name: 'Gourrama',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '141',
		name: 'Guelmim',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '142',
		name: 'Guercif‎',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '143',
		name: 'Gueznaia',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '144',
		name: 'Guigou',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '145',
		name: 'Guisser',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '146',
		name: 'Had Bouhssoussen',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '147',
		name: 'Had Kourt',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '148',
		name: 'Haj Kaddour',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '149',
		name: 'Harhoura',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '150',
		name: 'Harte Lyamine',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '151',
		name: 'Hattane',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '152',
		name: 'Hrara',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '153',
		name: 'Ida Ougnidif',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '154',
		name: 'Ifrane',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '155',
		name: 'Ifri',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '156',
		name: 'Igdamen',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '157',
		name: "Ighil n'Oumgoun",
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '158',
		name: 'Ighoud',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '159',
		name: 'Ighounane',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '160',
		name: 'Ihddaden',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '161',
		name: 'Imassine',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '162',
		name: 'Imintanoute',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '163',
		name: 'Imouzzer Kandar',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '164',
		name: 'Imouzzer Marmoucha',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '165',
		name: 'Imzouren‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '166',
		name: 'Inahnahen‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '167',
		name: 'Inezgane',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '168',
		name: 'Irherm',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '169',
		name: 'Issaguen (Ketama)‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '170',
		name: 'Itzer',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '171',
		name: 'Jamâat Shaim',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '172',
		name: 'Jaâdar',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '173',
		name: 'Jebha',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '174',
		name: 'Jerada',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '175',
		name: 'Jorf',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '176',
		name: 'Jorf El Melha',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '177',
		name: 'Jorf Lasfar',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '178',
		name: 'Karia',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '179',
		name: 'Karia (El Jadida)‎',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '180',
		name: 'Karia Ba Mohamed‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '181',
		name: 'Kariat Arekmane',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '182',
		name: 'Kasba Tadla',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '183',
		name: 'Kassita',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '184',
		name: 'Kattara',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '185',
		name: 'Kehf Nsour',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '186',
		name: "Kelaat-M'Gouna",
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '187',
		name: 'Kerouna',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '188',
		name: 'Kerrouchen',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '189',
		name: 'Khemis Zemamra',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '190',
		name: 'Khenichet',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '191',
		name: 'Khouribga',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '192',
		name: 'Khémis Sahel',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '193',
		name: 'Khémisset',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '194',
		name: 'Khénifra',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '195',
		name: 'Ksar El Kébir',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '196',
		name: 'Kénitra',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '197',
		name: 'Laaounate',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '198',
		name: 'Laayoune‎',
		region: '11',
		country: 'Morocco'
	},
	{
		_id: '199',
		name: 'Lakhsas',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '200',
		name: 'Lakhsass',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '201',
		name: 'Lalla Mimouna',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '202',
		name: 'Lalla Takerkoust',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '203',
		name: 'Larache',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '204',
		name: 'Laâtamna',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '205',
		name: 'Loudaya',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '206',
		name: 'Loulad',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '207',
		name: 'Lqliâa',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '208',
		name: 'Lâattaouia',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '209',
		name: "M'diq",
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '210',
		name: "M'haya",
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '211',
		name: "M'rirt",
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '212',
		name: "M'semrir",
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '213',
		name: 'Madagh',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '214',
		name: 'Marrakech',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '215',
		name: 'Martil',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '216',
		name: 'Massa (Maroc)',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '217',
		name: 'Mechra Bel Ksiri',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '218',
		name: 'Megousse',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '219',
		name: 'Mehdia',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '220',
		name: 'Meknès‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '221',
		name: 'Midar',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '222',
		name: 'Midelt',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '223',
		name: 'Missour',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '224',
		name: 'Mohammadia',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '225',
		name: 'Moqrisset',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '226',
		name: 'Moulay Abdallah',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '227',
		name: 'Moulay Ali Cherif',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '228',
		name: 'Moulay Bouazza',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '229',
		name: 'Moulay Bousselham',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '230',
		name: 'Moulay Brahim',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '231',
		name: 'Moulay Idriss Zerhoun',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '232',
		name: 'Moulay Yaâcoub',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '233',
		name: 'Moussaoua',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '234',
		name: 'MyAliCherif',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '235',
		name: 'Mzouda',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '236',
		name: 'Médiouna',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '237',
		name: "N'Zalat Bni Amar",
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '238',
		name: 'Nador',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '239',
		name: 'Naima',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '240',
		name: 'Oualidia',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '241',
		name: 'Ouaouizeght',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '242',
		name: 'Ouaoumana',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '243',
		name: 'Ouarzazate',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '244',
		name: 'Ouazzane',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '245',
		name: 'Oued Amlil‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '246',
		name: 'Oued Heimer',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '247',
		name: 'Oued Ifrane',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '248',
		name: 'Oued Laou',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '249',
		name: 'Oued Rmel',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '250',
		name: 'Oued Zem',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '251',
		name: 'Oued-Eddahab',
		region: '12',
		country: 'Morocco'
	},
	{
		_id: '252',
		name: 'Oujda',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '253',
		name: 'Oulad Abbou',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '254',
		name: 'Oulad Amrane',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '255',
		name: 'Oulad Ayad',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '256',
		name: 'Oulad Berhil',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '257',
		name: 'Oulad Frej',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '258',
		name: 'Oulad Ghadbane',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '259',
		name: "Oulad H'Riz Sahel",
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '260',
		name: "Oulad M'Barek",
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '261',
		name: "Oulad M'rah",
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '262',
		name: 'Oulad Saïd',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '263',
		name: 'Oulad Sidi Ben Daoud',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '264',
		name: 'Oulad Teïma',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '265',
		name: 'Oulad Yaich',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '266',
		name: 'Oulad Zbair‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '267',
		name: 'Ouled Tayeb',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '268',
		name: 'Oulmès',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '269',
		name: 'Ounagha',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '270',
		name: 'Outat El Haj',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '271',
		name: 'Point Cires',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '272',
		name: 'Rabat',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '273',
		name: 'Ras El Aïn',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '274',
		name: 'Ras El Ma',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '275',
		name: 'Ribate El Kheir',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '276',
		name: 'Rissani',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '277',
		name: 'Rommani',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '278',
		name: 'Sabaa Aiyoun',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '279',
		name: 'Safi',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '280',
		name: 'Salé',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '281',
		name: 'Sarghine',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '282',
		name: 'Saïdia',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '283',
		name: 'Sebt El Maârif',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '284',
		name: 'Sebt Gzoula',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '285',
		name: 'Sebt Jahjouh',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '286',
		name: 'Selouane',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '287',
		name: 'Settat',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '288',
		name: "Sid L'Mokhtar",
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '289',
		name: 'Sid Zouin',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '290',
		name: 'Sidi Abdallah Ghiat',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '291',
		name: 'Sidi Addi',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '292',
		name: 'Sidi Ahmed',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '293',
		name: 'Sidi Ali Ban Hamdouche',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '294',
		name: 'Sidi Allal El Bahraoui',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '295',
		name: 'Sidi Allal Tazi',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '296',
		name: 'Sidi Bennour',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '297',
		name: 'Sidi Bou Othmane',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '298',
		name: 'Sidi Boubker',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '299',
		name: 'Sidi Bouknadel',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '300',
		name: 'Sidi Bouzid',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '301',
		name: 'Sidi Ifni',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '302',
		name: 'Sidi Jaber',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '303',
		name: 'Sidi Kacem',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '304',
		name: 'Sidi Lyamani',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '305',
		name: 'Sidi Mohamed ben Abdallah el-Raisuni',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '306',
		name: 'Sidi Rahhal',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '307',
		name: 'Sidi Rahhal Chataï',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '308',
		name: 'Sidi Slimane',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '309',
		name: 'Sidi Slimane Echcharaa',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '310',
		name: 'Sidi Smaïl',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '311',
		name: 'Sidi Taibi',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '312',
		name: 'Sidi Yahya El Gharb',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '313',
		name: 'Skhinate',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '314',
		name: 'Skhirate',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '315',
		name: 'Skhour Rehamna',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '316',
		name: 'Skoura',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '317',
		name: 'Smimou',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '318',
		name: 'Soualem',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '319',
		name: 'Souk El Arbaa',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '320',
		name: 'Souk Sebt Oulad Nemma',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '321',
		name: 'Stehat',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '322',
		name: 'Séfrou',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '323',
		name: 'Tabounte',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '324',
		name: 'Tafajight',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '325',
		name: 'Tafetachte',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '326',
		name: 'Tafraout',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '327',
		name: 'Taghjijt',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '328',
		name: 'Taghzout',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '329',
		name: 'Tagzen',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '330',
		name: 'Tahannaout',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '331',
		name: 'Tahla‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '332',
		name: 'Tala Tazegwaght‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '333',
		name: 'Taliouine',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '334',
		name: 'Talmest',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '335',
		name: 'Talsint',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '336',
		name: 'Tamallalt',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '337',
		name: 'Tamanar',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '338',
		name: 'Tamansourt',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '339',
		name: 'Tamassint‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '340',
		name: 'Tamegroute',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '341',
		name: 'Tameslouht',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '342',
		name: 'Tamesna',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '343',
		name: 'Tamraght',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '344',
		name: 'Tan-Tan',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '345',
		name: 'Tanalt',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '346',
		name: 'Tanger‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '347',
		name: 'Tanoumrite Nkob Zagora',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '348',
		name: 'Taounate‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '349',
		name: 'Taourirt',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '350',
		name: 'Taourirt ait zaghar',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '351',
		name: 'Tarfaya‎',
		region: '11',
		country: 'Morocco'
	},
	{
		_id: '352',
		name: 'Targuist‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '353',
		name: 'Taroudannt',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '354',
		name: 'Tata',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '355',
		name: 'Taza‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '356',
		name: 'Taïnaste‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '357',
		name: 'Temsia',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '358',
		name: 'Tendrara',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '359',
		name: 'Thar Es-Souk‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '360',
		name: 'Tichoute',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '361',
		name: 'Tiddas',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '362',
		name: 'Tiflet',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '363',
		name: 'Tifnit',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '364',
		name: 'Tighassaline',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '365',
		name: 'Tighza',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '366',
		name: 'Timahdite',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '367',
		name: 'Tinejdad',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '368',
		name: 'Tisgdal',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '369',
		name: 'Tissa‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '370',
		name: 'Tit Mellil',
		region: '6',
		country: 'Morocco'
	},
	{
		_id: '371',
		name: 'Tizguite',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '372',
		name: 'Tizi Ouasli‎',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '373',
		name: 'Tiznit',
		region: '9',
		country: 'Morocco'
	},
	{
		_id: '374',
		name: 'Tiztoutine',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '375',
		name: 'Touarga',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '376',
		name: 'Touima',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '377',
		name: 'Touissit',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '378',
		name: 'Toulal',
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '379',
		name: 'Toundoute',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '380',
		name: 'Tounfite',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '381',
		name: 'Témara',
		region: '4',
		country: 'Morocco'
	},
	{
		_id: '382',
		name: 'Tétouan‎',
		region: '1',
		country: 'Morocco'
	},
	{
		_id: '383',
		name: 'Youssoufia',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '384',
		name: 'Zag',
		region: '10',
		country: 'Morocco'
	},
	{
		_id: '385',
		name: 'Zagora',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '386',
		name: "Zaouia d'Ifrane",
		region: '3',
		country: 'Morocco'
	},
	{
		_id: '387',
		name: 'Zaouïat Cheikh',
		region: '5',
		country: 'Morocco'
	},
	{
		_id: '388',
		name: 'Zaïda',
		region: '8',
		country: 'Morocco'
	},
	{
		_id: '389',
		name: 'Zaïo',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '390',
		name: 'Zeghanghane',
		region: '2',
		country: 'Morocco'
	},
	{
		_id: '391',
		name: 'Zeubelemok',
		region: '7',
		country: 'Morocco'
	},
	{
		_id: '392',
		name: 'Zinat',
		region: '1',
		country: 'Morocco'
	}
];

export const PLANS = [
	{
		title: 'Basic',
		price: 99,
		features: [
			{
				name: 'Project',
				isAllowed: true,
				limit: 1,
				description: 'One allowed project'
			},
			{
				name: 'Invoice Management',
				isAllowed: true,
				limit: 100,
				description: '200 invoices as limit and one invoices model'
			},
			{
				name: 'Stock Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Cash Journal',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Expense Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Earning Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Human Resource',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Booking Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Orders Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Turnover Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			}
		]
	},
	{
		title: 'Popular',
		price: 299,
		features: [
			{
				name: 'Project',
				isAllowed: true,
				limit: 1,
				description: '2 allowed projects'
			},
			{
				name: 'Invoice Management',
				isAllowed: true,
				limit: 100
			},
			{
				name: 'Stock Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Cash Journal',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Expense Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Earning Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Human Resource',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Booking Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Orders Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Turnover Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			}
		]
	},
	{
		title: 'Advanced',
		price: 499,
		features: [
			{
				name: 'Project',
				isAllowed: true,
				limit: 1,
				description: '2 allowed projects'
			},
			{
				name: 'Invoice Management',
				isAllowed: true,
				limit: 100
			},
			{
				name: 'Stock Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Cash Journal',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Expense Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Earning Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Human Resource',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Booking Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Orders Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			},
			{
				name: 'Turnover Management',
				isAllowed: true,
				description: '200 operations add/retry',
				limit: 200
			}
		]
	}
];

export const GlobalCharts = {
	widget: {
		simple: { type: 'Simple', title: 'Simple Widget', icons: widget?.svgIcons, default: widget?.defaultWidget }
		// progressChart: {
		// 	type: 'Progress Chart',
		// 	title: 'Progress Chart Widget',
		// 	icons: widget?.svgIcons,
		// 	default: widget?.progressChartWidget
		// }
	},
	lineChart: {
		splineArea1: { type: 'apex', title: 'Area Spaline Chart', chart: apexChartData.splineArea1 },
		visitorArea1: { type: 'apex', title: 'Area Visitors', chart: apexChartData.visitorChart },
		ordersArea1: { type: 'apex', title: 'Area Orders', chart: apexChartData.monthOrderChart },
		splineArea2: { type: 'apex', title: 'Basic Area Chart', chart: apexChartData.splineArea2 },
		areaChart1: { type: 'google', title: 'Area Chart 1', chart: googleChartData.areaChart1 },
		areaChart2: { type: 'google', title: 'Area Chart 2', chart: googleChartData.areaChart2 },
		lineChart: { type: 'google', title: 'Line Chart', chart: googleChartData.lineChart }
	},
	barChart: {
		column: { type: 'apex', title: 'Column Chart', chart: apexChartData.column },
		column2: {
			type: 'apex',
			title: 'Activity Hours Chart',
			chart: apexChartData.activityHoursChart,
			hasDefaultDisplay: true
		},
		bar: { type: 'apex', title: 'Bar chart', chart: apexChartData.bar },
		comboChart: { type: 'google', title: 'Combo Chart', chart: googleChartData.comboChart },
		columnChart1: { type: 'google', title: 'Column Chart 1', chart: googleChartData.columnChart1 },
		columnChart2: { type: 'google', title: 'Column Chart 2', chart: googleChartData.columnChart2 }
	},
	circleChart: {
		pie: { type: 'apex', title: 'Pie Chart', chart: apexChartData.pie, class: 'apex-chart' },
		donut: { type: 'apex', title: 'Donut Chart', chart: apexChartData.donut, class: 'apex-chart' },
		// profitChart: { type: 'apex', title: 'Profit Chart', chart: apexChartData.monthlyProfitsChart, class: 'apex-chart' },
		pieChart1: { type: 'google', title: 'Pie Chart 1', chart: googleChartData.pieChart1 },
		pieChart2: { type: 'google', title: 'Pie Chart 2', chart: googleChartData.pieChart2 },
		pieChart3: { type: 'google', title: 'Pie Chart 3', chart: googleChartData.pieChart3 },
		pieChart4: { type: 'google', title: 'Pie Chart 4', chart: googleChartData.pieChart4 }
	},
	tableChart: {
		ordersByCategories: {
			type: 'table',
			component: OrdersByCategoriesComponent,
			tableStyle: defaultOrdersByCategoriesStyle,
			operations: [
				{ value: 'Top Products By Categories', label: 'Top Products By Categories' },
				{ value: 'Top Consumed Products By Categories', label: 'Top Consumed Products By Categories' }
			]
		},
		inverseTableBackground: {
			type: 'table',
			component: InverseTableBackgroundComponent,
			tableStyle: inverseTableBackgroundStyle,
			operations: [
				{ value: 'Top Products By Categories', label: 'Top Products By Categories' },
				{ value: 'Top Consumed Products By Categories', label: 'Top Consumed Products By Categories' }
			]
		},
		topSellingProducts: {
			type: 'card',
			component: TopSellingProductsComponent,
			tableStyle: defaultTopSellingProductsStyle,
			operations: [
				{ value: 'Top Selling Products', label: 'Top Selling Products' },
				{ value: 'Top Consumed Products', label: 'Top Consumed Products' }
			]
		}
	}
};

export const GlobalAppsForApiIntegration = [
	{ appCode: 'sendit', title: 'Sendit', logo: 'sendit-logo.webp', apiRoute: 'https://app.sendit.ma/api/v1/' },
	{ appCode: 'cathedis', title: 'Cathedis', logo: 'cathedis-logo.webp', apiRoute: null },
	{ appCode: 'olivraison', title: 'Olivraison', logo: 'olivraison-logo.webp', apiRoute: null },
	{ appCode: 'onessta', title: 'Onessta', logo: 'onessta-logo.webp', apiRoute: null },
	{ appCode: 'ameex', title: 'Ameex', logo: 'ameex-logo.webp', apiRoute: null },
	{ appCode: 'ozon', title: 'Ozon', logo: 'ozon-logo.webp', apiRoute: null }
];
export const VendorRoles = [
	{ label: 'Supplier', value: 'supplier' },
	{ label: 'Client', value: 'client' },
	{ label: 'Mixed', value: 'mixed' }
];

export const GlobalApps: any = Object.values(GlobalVariable).filter((elem: any) => elem?.isApp);
export const GlobalAppsSortedByOrder: any = Object.values(GlobalVariable)
	.filter((elem: any) => elem?.isApp)
	.sort((a: any, b: any) => (a.order ?? 0) - (b.order ?? 0));

export const GlobalChildApps: any = Object.values(GlobalVariable).filter((elem: any) => elem?.isChildApp);
export const GlobalAdminComponents: any = Object.values(GlobalVariable).filter((elem: any) => elem?.isAdmin);
export const GlobalConfigComponents: any = Object.values(GlobalVariable).filter(
	(elem: any) => elem?.isConfig && elem?.isComponent
);
export const GlobalAllConfigComponents: any = Object.values(GlobalVariable).filter(
	(elem: any) => elem?.isConfig && (elem?.isComponent || elem?.isChildComponent)
);
export const GlobalAppsFields: any = Object.keys(GlobalVariable).reduce((acc, key) => {
	if (GlobalVariable[key]?.isApp && GlobalVariable[key].appFields) {
		if (key == 'STOCK') {
			acc['STOCK_MANAGEMENT'] = GlobalVariable[key].appFields;
		} else {
			acc[key] = GlobalVariable[key].appFields;
		}
	}
	return acc;
}, {} as Record<string, any[]>);

export const GlobalConfigFields: any = Object.keys(GlobalVariable).reduce((acc, key) => {
	if (GlobalVariable[key]?.isConfig == true && GlobalVariable[key]?.appFields) {
		acc[key] = GlobalVariable[key]?.appFields ?? {};
	}
	return acc;
}, {} as Record<string, any[]>);
